import { get, post, patch, del } from './client.js';
const base = (wsId) => `/workspaces/${wsId}/goals`;
export const list       = (wsId)            => get(base(wsId));
export const create     = (wsId, dto)       => post(base(wsId), dto);
export const update     = (wsId, id, dto)   => patch(`${base(wsId)}/${id}`, dto);
export const remove     = (wsId, id)        => del(`${base(wsId)}/${id}`);
export const checkIn    = (wsId, id, dto)   => post(`${base(wsId)}/${id}/check-in`, dto);
export const getSummary = (wsId)            => get(`${base(wsId)}/summary`);
